// extracted by mini-css-extract-plugin
export default {"commentsLoader":"Comments-module__commentsLoader"};